import { ComponentProps, useCallback, useContext } from 'react';
import { useActivePosEntityContext } from 'src/contexts/ActivePosEntityContext';
import { Content } from 'src/contexts/ContentContext';
import { ModalContext } from 'src/contexts/ModalContext';
import { Button } from 'src/core/ui';
import { ModalProps } from 'src/modals/Modal';
import { ViewSeatsListModal } from 'src/modals/ViewSeatsListModal';
import { ContentId } from 'src/utils/constants/contentId';
import {
  ActionOutboxEntityType,
  ListingDetailDataField,
  ListingDetails,
} from 'src/WebApiController';

export const LaunchViewAllSeats = ({
  listingId,
  marketplaceListingId,
  cancelTo,
  seeAvailableSeats,
  seeWastedSeats,
  modalSize,
}: {
  listingId: number;
  marketplaceListingId?: string | null;
  disabled?: boolean;
  modalSize?: ModalProps['size'];
} & ComponentProps<typeof ViewSeatsListModal>) => {
  const { setModal } = useContext(ModalContext);
  const { posEntity: listing, setActivePosEntity } =
    useActivePosEntityContext<ListingDetails>();

  const viewComps = useCallback(() => {
    setModal({
      children: (
        <ViewSeatsListModal
          cancelTo={cancelTo}
          seeAvailableSeats={seeAvailableSeats}
          seeWastedSeats={seeWastedSeats}
        />
      ),
      clickOutsideToClose: true,
      size: modalSize ?? 'slide-in',
      deepLinkValue: listingId,
      trackViewEntityType: ActionOutboxEntityType.Listing,
    });
  }, [
    setModal,
    cancelTo,
    seeAvailableSeats,
    seeWastedSeats,
    modalSize,
    listingId,
  ]);

  const onLaunchDialog = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      setActivePosEntity(listingId, marketplaceListingId, true, [
        ListingDetailDataField.Basic,
        ListingDetailDataField.Tickets,
      ]);
      viewComps();
    },
    [setActivePosEntity, listingId, marketplaceListingId, viewComps]
  );

  return (
    <Button variant={'link'} onClick={onLaunchDialog}>
      <Content id={ContentId.SeeAll} />
    </Button>
  );
};
